<script lang="ts">
	//Hooks
	import { createEventDispatcher, getContext, tick, onDestroy } from 'svelte';
	//Config
	import { mapbox_map_config } from '../../../helpers/geolocalion_helper';
	//Components
	import SearchFieldBox from '../autocomplete/SearchFieldBox.svelte';
	import SelectDataList from '../autocomplete/SelectDataList.svelte';
	import SelectOption from '../autocomplete/SelectOption.svelte';
	// Design system components
	import { Icon, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { MapContext } from '../../../types/requests/services/weather';

	const { getMap }: MapContext = getContext('map'),
		map = getMap(),
		dispatcher = createEventDispatcher();

	let geocoderIsLoaded = false,
		searchFieldBox: SearchFieldBox,
		results = [];

	const onLoadMapboxGeocoder = async () => {
		geocoderIsLoaded = true;
		await tick();
		map.on('dragstart', closeSearchBox);
	};

	onDestroy(() => {
		if (map) map.off('dragstart', closeSearchBox);
	});

	const getResult = async (e) => {
		const search = e.detail.trim().toLowerCase();
		if (!search) {
			results = [];
			return;
		}
		const geocoderURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(
				search,
			)}.json?proximity=ip&types=place&access_token=${mapbox_map_config.apiKey}`,
			req = await fetch(geocoderURL);
		if (!req.ok) return;
		const res = await req.json();
		results = [];
		if (res.query.join(' ').trim() == search) {
			const len = res.features.length;
			for (let i = 0; i < len; ++i) {
				const data = res.features[i];
				results = [
					...results,
					{
						lat: data.center[1],
						lon: data.center[0],
						placeName: data.place_name,
						search,
					},
				];
			}
		}
	};

	function onSelectClickHandler(result) {
		closeSearchBox();
		dispatcher('select', result);
	}

	function closeSearchBox() {
		results = [];
		searchFieldBox.close();
	}
</script>

{#if geocoderIsLoaded}
	<SearchFieldBox on:input={getResult} bind:this={searchFieldBox} on:click_outside={closeSearchBox}>
		<SelectDataList open={results.length} showItems={0}>
			{#each results as result, i}
				<SelectOption on:click={() => onSelectClickHandler(result)}>
					<div class="icon">
						<Icon size="xs" icon="fas fa-location-dot" />
					</div>
					<Text styleType="body-small" class="label">{result.placeName}</Text>
				</SelectOption>
			{/each}
		</SelectDataList>
	</SearchFieldBox>
{/if}

<svelte:head>
	<link
		rel="stylesheet"
		href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.css"
		type="text/css"
	/>
	<script
		src="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v5.0.0/mapbox-gl-geocoder.min.js"
		on:load={onLoadMapboxGeocoder}
	></script>
</svelte:head>

<style>
	.icon {
		height: 16px;
		padding-right: 8px;
	}
</style>
